import { Box, Select, MenuItem as MuiMenuItem, FormControl, Typography, Popper as MuiPopper } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const StyledFormControl = styled(FormControl)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 181px;
`

export const Label = styled(Typography)`
  color: ${theme.colors.menuItemText};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.normal};
  line-height: 22px;
`

export const StyledSelect = styled(Select)`
  height: 48px;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.dropdownBorder};
  background-color: transparent;
  min-width: 131px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${theme.colors.cta};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 20px;

  .MuiSelect-select {
    padding: 14px ${theme.spacing.small}px;
    display: flex;
    align-items: center;
  }

  &:hover {
    border-color: #6c5b67;
  }

  .MuiSvgIcon-root {
    color: ${theme.colors.cta};
    right: ${theme.spacing.small}px;
  }

  &.Mui-focused {
    border-color: ${theme.colors.cta};

    .MuiSvgIcon-root {
      transform: rotate(180deg);
    }
  }

  fieldset {
    border: none;
  }
`

export const MenuItem = styled(MuiMenuItem)`
  background: ${theme.colors.borderMedium};

  html[data-theme='light'] & {
    background: ${theme.colors.surfaceContainerBackground};
  }
  border-radius: ${theme.attributes.borderRadius.tertiary};
  padding: 0;

  &:not(:last-of-type) {
    margin-bottom: ${theme.spacing.lg}px;
  }

  &:hover {
    cursor: default;
    background: unset;
  }
`

export const MenuItemContent = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${theme.spacing.xSmall}px;
`

export const MenuItemLabel = styled(Typography)`
  color: ${theme.colors.menuItemText};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.normal};
  font-style: normal;
  line-height: 22px;
  flex-grow: 1;
`

export const MenuItemValueWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.small}px;
  padding: 14px 12px 14px ${theme.spacing.small}px;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.dropdownBorder};
  height: 48px;
  overflow: hidden;

  .value-with-count {
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 1;
    min-width: 0;
    overflow: hidden;

    .truncated-value {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .additional {
      flex-shrink: 0;
      flex-grow: 0;
    }
  }

  .MuiTypography-root {
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    color: ${theme.colors.cta};
    letter-spacing: 0.1px;
    white-space: nowrap;

    &.additional {
      min-width: fit-content;
      flex-shrink: 0;
    }
  }

  > .MuiTypography-root {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .MuiIconButton-root {
    color: ${theme.colors.devicesSecondaryText};
    flex-shrink: 0;
  }

  &:hover {
    border-color: #6c5b67;

    .MuiIconButton-root {
      cursor: pointer;
      background: unset;
      color: ${theme.colors.cta};
    }
  }
`

export const Popper = styled(MuiPopper)`
  background-color: ${theme.colors.borderMedium};

  html[data-theme='light'] & {
    background-color: ${theme.colors.surfaceContainerBackground};
  }
  border: 0;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  box-shadow: 0 4px 8px 0 rgba(30, 26, 29, 0.2);
  margin-top: ${theme.spacing.xSmall}px !important;
  max-height: 300px;
  padding: ${theme.spacing.sm}px ${theme.spacing.small}px ${theme.spacing.small}px;
  width: 244px;
  z-index: 10000;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
    background: transparent;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.surfaceContainerBackground};
    border-radius: 2px;
  }

  .MuiList-root {
    padding: 0;
  }
`

export const PopperInner = styled(Box)``
